// extracted by mini-css-extract-plugin
module.exports = {"ContactInfo":"ContactInfo_ContactInfo__24guG"};